import React, { Component } from 'react';
import { Alert, Button } from 'react-bootstrap';

import AppVo from '../blogData/AppVo';
import MainController from '../classes/MainController';

import { MainStorage } from '../classes/MainStorage';
import { StartData } from '../classes/StartData';
import BlockScreen from './BlockScreen';
import DashScreen from './DashScreen';
import GenScreen from './GenScreen';
import ModScreen from './ModScreen';
import SavesScreen from './SavesScreen';

interface MyProps { }
interface MyState { mode: number, selectedApp: AppVo | null, flashMessage: string }
class BaseScreen extends Component<MyProps, MyState>
{
    private ms: MainStorage = MainStorage.getInstance();
    private mc: MainController = MainController.getInstance();

    private catID: number = 0;
    private listID: number = 0;
    private startApp: string = "";

    constructor(props: MyProps) {
        super(props);
        this.state = { mode: 0, selectedApp: null, flashMessage: "" };

    }
    componentDidMount() {
        const userCodeDiv: HTMLDivElement | null = document.getElementById("uc2") as HTMLDivElement;
        if (userCodeDiv) {

            this.ms.userCode = userCodeDiv.innerText;
        }
        else {
            this.ms.userCode = "";
            console.log("No user code found");
        }
        if (this.ms.userCode.length > 0) {
            let sd: StartData = new StartData(this.gotAppInfo.bind(this));
            sd.getAppInfo();
            this.mc.showFlashMessage = (message: string) => { this.setState({ flashMessage: message }); }
        }
    }
    gotAppInfo() {
        this.setState({ mode: 1 });
        const startAppDiv: HTMLDivElement | null = document.getElementById("startApp") as HTMLDivElement;
        let startApp: string = "";
        if (startAppDiv) {
            startApp = startAppDiv.innerText || "";
        }
        if (startApp.length > 0) {
            this.startApp = startApp;
            this.setState({ selectedApp: this.ms.getAppBySlug(startApp) });
        }
    }


    selectCard(appVo: AppVo) {
        console.log(appVo);
        this.setState({ selectedApp: appVo });
    }
    getScreen() {
        switch (this.state.mode) {

            case 0:
                return "LOADING";
            case 1:

                return <DashScreen callback={this.selectCard.bind(this)}></DashScreen>

            case 2:
                return <SavesScreen></SavesScreen>
        }
    }
    getMod() {
        if (this.state.selectedApp !== null) {
            console.log(this.state.selectedApp);

            let link: string = this.state.selectedApp.link;

            if ((this.ms.isUserLoggedIn === false || this.ms.isMembershipActive === false) && this.state.selectedApp.paid === 1) {
                link = this.state.selectedApp.freeLink;
            }
            console.log("Link=" + link);

            if (link.startsWith("mod")) {
                return <GenScreen appVo={this.state.selectedApp} callback={() => { this.setState({ selectedApp: null }) }}></GenScreen>
            }
            if (link === "") {
                return <BlockScreen callback={() => { this.setState({ selectedApp: null }) }}></BlockScreen>
            }
            return <ModScreen appVo={this.state.selectedApp} callback={() => { this.setState({ selectedApp: null }) }}></ModScreen>
        }
        return <div></div>
    }
    showFlashMessage() {
        if (this.state.flashMessage !== "") {
            setTimeout(() => {
                this.setState({ flashMessage: "" });
            }, 3000)
            return <div className="flash-message"><Alert variant='success'>{this.state.flashMessage}</Alert></div>
        }
        return ""
    }
    /*  <div className='main-title'>{(this.state.mode===1)?"Pick an App below to get started":"Saved Text"}</div> */
    render() {
        return <div>
            <div className='container'>
                <div className="tac">
                    <Button variant={(this.state.mode === 2) ? "outline-primary" : "primary"} size="sm" onClick={() => { this.setState({ mode: 1 }) }}>Apps</Button>
                    <Button variant={(this.state.mode === 1) ? "outline-primary" : "primary"} size="sm" onClick={() => { this.setState({ mode: 2 }) }}>My Content</Button>

                </div>
                {this.getMod()}
                {this.getScreen()}
                {this.showFlashMessage()}
            </div>
        </div>;
    }
}
export default BaseScreen;